import uuid from 'react-uuid'
import Swal from 'sweetalert2'
import { GET, POST } from '../../../../services/api'
import { AggregatorClassification } from '../../AggregadorCategory/aggregadorCategory.type'
import { CreateLojaAgregadorDTO, LojaAgregador } from '../type'

export async function saveImage(image1: any, name: string, retries: number = 3): Promise<{ success: boolean; url: string; error?: string }> {
    let lastError: any = null

    for (let attempt = 1; attempt <= retries; attempt++) {
        try {
            if (typeof image1 !== 'string') {
                const formData = new FormData()
                formData.append('file', image1)
                formData.append('nameImage', `store-${name}-${uuid()}.jpg`)
                formData.append('originalSize', 'true')
                const imageRes = await POST('/upload-images/upload-one', formData)

                if (imageRes.success) {
                    return {
                        success: true,
                        url: imageRes.image,
                    }
                } else {
                    lastError = 'Resposta do servidor indicou falha'
                }
            } else {
                return {
                    success: true,
                    url: image1,
                }
            }
        } catch (error) {
            lastError = error
            if (attempt < retries) {
                await new Promise(resolve => setTimeout(resolve, 500 * attempt)) // wait before retry
                continue
            }
        }
    }

    return {
        success: false,
        url: '',
        error: `Falha ao enviar imagem "${name}" após ${retries} tentativas`,
    }
}

export async function getAgregadorClassification(): Promise<AggregatorClassification[]> {
    try {
        const currentPage = 0
        const currentPageSize = 5000
        const currentSearch = ''
        const currentSorting = 'ASC'

        const query = `?field=id&order=${currentSorting}&page=${currentPage}&take=${currentPageSize}&search=${currentSearch}`

        const request = await GET(`aggregator-classification${query}`)

        return request.data
    } catch (error) {
        return []
    }

}

export function validateForm(data: CreateLojaAgregadorDTO): boolean {
    const requiredFields: Array<{ value: unknown; name: string }> = [
        { value: data.image, name: 'image' },
        { value: data.order, name: 'order' },
        { value: data.name, name: 'name' },
        { value: data.description, name: 'description' },
        { value: data.order, name: 'order' },
        { value: data.classificationId, name: 'classificationId' },
        { value: data.corporatename, name: 'corporatename' },
        { value: data.corporateName, name: 'corporateName' },
        { value: data.cnpj, name: 'cnpj' },
        { value: data.zipCode, name: 'zipCode' },
    ]


    const hasEmptyRequiredField = requiredFields.some(({ value, name }) => {
        let res = false
        if (typeof value === 'string') res = value.trim() === ''
        if (typeof value === 'number') res = Number.isNaN(value)


        if (res) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção',
                text: `O campo: ${name} está vazio`
            })
        }

        return res
    })

    if (hasEmptyRequiredField) {
        return false
    }

    return true
}